import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const PermissionsContext = createContext({});

export const PermissionsProvider = ({ children }) => {
  const { user, getToken, dbUser } = useAuth();
  const [permissions, setPermissions] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const loadPermissions = async () => {
      if (!user || !dbUser) { setLoading(false); return; }
      if (dbUser.role === 'admin') {
        setIsAdmin(true);
        setPermissions(['*']);
        setLoading(false);
        return;
      }
      try {
        const token = await getToken();
        const res = await fetch(`${API}/api/auth/my-permissions`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setPermissions(data.permissions || []);
        setIsAdmin(data.isAdmin || false);
      } catch (err) {
        console.error('Permissions load error:', err);
      } finally {
        setLoading(false);
      }
    };
    loadPermissions();
  }, [user, dbUser]);

  const can = (permission) => {
    if (isAdmin) return true;
    if (permissions.includes('*')) return true;
    return permissions.includes(permission);
  };

  return (
    <PermissionsContext.Provider value={{ permissions, isAdmin, loading, can }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);